import React from 'react';
import Slider from 'infinite-react-carousel';

const Carousel = (props) => {
    const settings = {
        arrows: false,
        arrowsBlock: false,
        autoplay: true,
        autoplaySpeed: 6000,
        dots: true,
        className: 'carouselWrapper',
        gutter: 10,
        initialSlide: 1,
        wheel: true,
        wheelScroll: 2
    };
    const images = [
        'https://res.cloudinary.com/dfqkwnen0/image/upload/v1597954204/Video_Game_Console.H03.2k_i1kus4.png',
        'https://res.cloudinary.com/dfqkwnen0/image/upload/v1597954204/Portable_Generator.H03.2k_rifvfj.png',
        'https://res.cloudinary.com/dfqkwnen0/image/upload/v1597954204/Laptop_Computer.H03.2k_dncqvo.png',
        'https://res.cloudinary.com/dfqkwnen0/image/upload/v1597954204/Dryer.H03.2k_tu5alr.png',
        'https://res.cloudinary.com/dfqkwnen0/image/upload/v1597954204/Air_Conditioner.H03.2k_esl3ar.png',
        'https://res.cloudinary.com/dfqkwnen0/image/upload/v1597954204/iPhone_XS.H03.2k_m30oqs.png'
    ]
    return (
        <Slider {...settings}>
            {images.map((img, index) => {
                return (
                    <div key={index}>
                        <img className="image is-16by9" src={img} style={{ paddingTop: 0 }} />
                    </div>
                )
            })}
        </Slider>
    );
}

export default Carousel;